// extracted by mini-css-extract-plugin
module.exports = {"background":"InitialLoadProgress_background__104TE","foreground":"InitialLoadProgress_foreground___lf0d","companyColor":"InitialLoadProgress_companyColor__2oq5Q"};